import {Expose} from "class-transformer";

export default class PaymentWalletBalance {
	@Expose({ name: 'amount' })
	private _amount: number = 0;

	get amount(): number {
		return this._amount;
	}
}
